import { type EpilotControlProps } from '@epilot/journey-logic-commons'
import type { MemoExoticComponent } from 'react'

import {
  BlockContent,
  BlockHeading
} from '../../concorde-renderers/layouts/components'
import { useJourneyContext } from '../providers'

import { determineBlockDisabledStatus } from './displaySettings'

type Component = (props: EpilotControlProps) => JSX.Element | null

type IncludeCommonOptions = {
  component: Component | MemoExoticComponent<Component>
}

export function includeCommon({ component: Component }: IncludeCommonOptions) {
  const WrappedComponent = ({ ...props }: EpilotControlProps) => {
    const { uischema, enabled: enabledFromJsonForms, path } = props

    const { context } = useJourneyContext()

    const { options } = uischema
    const isNested = options?.isNested

    const disabledFields =
      (context.blocksDisplaySettings
        ? determineBlockDisabledStatus(
            context.blocksDisplaySettings,
            context._navigationInfo.currentStepIndex,
            uischema.scope
          )
        : false) || !enabledFromJsonForms

    if (uischema.options?.display === false) return null

    const requiredBlocks =
      context.journey.steps[context._navigationInfo.currentStepIndex].schema
        .required

    const content = (
      <BlockHeading
        required={requiredBlocks?.includes(path)}
        subtitle={options?.subtitle}
        title={options?.title}
      >
        <Component
          disabledFields={
            Array.isArray(disabledFields) ? disabledFields : undefined
          }
          {...props}
          enabled={!disabledFields}
        />
      </BlockHeading>
    )

    return (
      <BlockContent
        isGroup={!isNested}
        showCard={options?.showPaper && !isNested}
      >
        {content}
      </BlockContent>
    )
  }

  return WrappedComponent
}
